export default __webpack_public_path__ + "static/khoa-hoc-online-text-3-2f1c81265fdc0a15f143ec82ded8a112.svg";